/* BundleIcon.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives/responsive';
import { DarkModeLogoBackground, Icon } from '@atlassian/mpac-ui';
import React from 'react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _3 = "@media (min-width:48rem){._14b51mfw{width:5.875rem}._1xlo1mfw{height:5.875rem}}";
const _2 = "._4t3i1k7u{height:3.5rem}";
const _ = "._1bsb1k7u{width:3.5rem}";
const IconContainer = null;
const BundleIcon = props => {
  const {
    bundleKey,
    bundleIconLink,
    icon
  } = props;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1bsb1k7u _4t3i1k7u _14b51mfw _1xlo1mfw"]),
      children: /*#__PURE__*/_jsx(DarkModeLogoBackground, {
        children: /*#__PURE__*/_jsx(Icon, {
          uniqueKey: bundleKey,
          iconUrl: bundleIconLink,
          fallbackIconUrl: icon,
          iconType: "app"
        })
      })
    })]
  });
};
export default BundleIcon;